export default __webpack_public_path__ + "static/media/046.4cb49890.jpg";